import { styled } from '../../../stitches.config';
import { chassisVars } from './utils';

export const ChassisRow = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  gap: `$${chassisVars.gap.slot}`,
  height: `$${chassisVars.slot.heightWithIndicators}`,
});
ChassisRow.displayName = 'ChassisRow';
